// src/pages/debitNote/DebitNoteA4Document.jsx
import React from 'react';
import { useLocalization } from '../../contexts/LocalizationContext';
import { formatCurrency } from '../../utils/orderCalculations';
import A4DocumentLayout from '../../components/common/A4DocumentLayout/A4DocumentLayout';

const DebitNoteA4Document = ({ debitNote }) => {
  const { t } = useLocalization();

  if (!debitNote) return null;

  const remaining = Math.max(0, Number(debitNote.amount || 0) - Number(debitNote.appliedAmount || 0));

  return (
    <A4DocumentLayout
      title={t('debitNote.debitNoteNumber')}
      subtitle={t('debitNote.officialDebitNote', 'Official Debit Note')}
      documentNumber={`#${debitNote.debitNoteNumber}`}
      metaRows={[
        { label: t('common.created'), value: new Date(debitNote.createdAt).toLocaleString() },
        { label: t('common.status'), value: (debitNote.status || '').toUpperCase() },
        ...(debitNote.issuedBy?.name ? [{ label: t('returnToVendor.createdBy'), value: debitNote.issuedBy.name }] : []),
      ]}
      infoCards={[
        {
          title: t('debitNote.supplier'),
          primary: debitNote.Supplier?.name || t('common.na'),
          lines: [`${t('debitNote.purchaseOrderNumber')}: #${debitNote.purchaseOrder?.purchaseOrderNumber || t('common.na')}`],
        },
        {
          title: t('debitNote.sourceType'),
          lines: [t(`debitNote.sourceType_${debitNote.sourceType}`)],
        },
      ]}
      summary={{
        notes: { label: t('debitNote.reason'), text: debitNote.reason || t('common.none', 'None') },
        totals: [
          { label: t('debitNote.amount'), value: formatCurrency(debitNote.amount) },
          { label: t('debitNote.appliedAmount'), value: formatCurrency(debitNote.appliedAmount) },
          { label: t('debitNote.remainingAmount'), value: formatCurrency(remaining), variant: 'grand' },
        ],
      }}
      footerNote="This is a computer-generated debit note."
    />
  );
};

export default DebitNoteA4Document;
